import React, { useCallback } from 'react';

import { useMixpanel } from '../../functions/Mixpanel';
import Clinic from '../../images/home/clinic.webp';
import Microscope from '../../images/home/microscope.webp';
import Operations from '../../images/home/operations.webp';
import { Section } from '../Section';

import { Persona } from './Persona';

const WhoIsItFor = () => {
  const { mixpanel } = useMixpanel();

  const trackReadMore = useCallback(
    (value: 'Clinic' | 'Lab' | 'Operations') => {
      mixpanel.track(`View ${value}`);
    },
    [mixpanel],
  );

  return (
    <Section className={classNames.container}>
      <div className={classNames.titleContainer}>
        <h3 className={classNames.eyebrow}>Who it&apos;s for</h3>
        <h1 className={classNames.title}>
          An ecosystem of products designed to empower every member of the
          clinic
        </h1>
      </div>
      <div className={classNames.personaContainer}>
        <Persona
          imgSrc={Clinic}
          title="Clinic"
          description="Optimize the number of MIIs retrieved from an ovarian stimulation cycle"
          learnMoreUrl="/stim-assist"
          onClick={() => trackReadMore('Clinic')}
        />
        <Persona
          imgSrc={Microscope}
          title="Lab"
          description="Standardize embryo grading workflow while improving quality control and record keeping"
          learnMoreUrl="/embryo-assist"
          imgRight
          onClick={() => trackReadMore('Lab')}
        />
        <Persona
          imgSrc={Operations}
          title="Operations"
          description="Monitor clinic KPIs in real-time, increasing efficiency and saving critical time and money"
          learnMoreUrl="/platform/#:~:text=LEARN%20MORE-,INSIGHTS,-Monitor%20clinic%20KPIs"
          onClick={() => trackReadMore('Operations')}
        />
      </div>
    </Section>
  );
};

const classNames = {
  container: [].join(' '),
  titleContainer: [
    'tw-flex',
    'tw-flex-col',
    'tw-items-center',
    'md:tw-items-start',
    'tw-text-center',
    'md:tw-text-start',
    'tw-gap-[16px]',
    'md: tw-gap-[24px]',
    'tw-mb-[48px]',
  ].join(' '),
  eyebrow: ['tw-subtitle'].join(' '),
  title: ['tw-display3'].join(' '),
  personaContainer: [
    'tw-flex',
    'tw-flex-col',
    'tw-gap-[48px]',
    'md:tw-gap-[80px]',
    'xl:tw-gap-0',
  ].join(' '),
};

export { WhoIsItFor };
